<template>
  <div>
    <div v-if="this.condition">
      <div v-show="false">{{question}}</div>
      <template v-for="ids in this.question['multiple_ids']">
        <div v-if="Object.keys(question.answers[ids].questions).length">
          <div v-for="child_question in question.answers[ids].questions">
            <div class="col-md-12" v-if="checkVisibilityOfQuestion(child_question) === true && child_question['available'] === true">
              <div class='row padding '>
                <div class="col-md-7 " >
                  <label class="required">
                    {{ computeCaption(child_question.name, $store.state.lang.value.toLowerCase()) }}
                  </label>
                </div>
                <div class="col-md-5" >
                  <div v-if="child_question.type === 'Combobox Toggle'">
                    <el-radio-group
                      size="small"
                      value-key="answer_id"
                      :name="child_question.valueHolder === undefined || child_question.valueHolder.length === 0 ? 'invalidQuestion' : ''"
                      v-model="child_question.valueHolder"
                      @change="onAnswerChange(child_question)"
                    >
                      <el-radio-button
                        v-for="answer_id in child_question.sorted_answer_ids"
                        v-if="child_question['answers'][answer_id]['available']"
                        class="select-danger"
                        :class="child_question['answers'][answer_id]['strikethrough'] === true ? 'strikethrough' : ''"
                        tabindex="0"
                        :key="answer_id"
                        :label="child_question['answers'][answer_id].name"
                        :value="{
                            answer_id: answer_id,
                            answer_name: child_question['answers'][answer_id].name
                          }"
                      >{{computeCaption(child_question['answers'][answer_id].name, $store.state.lang.value.toLowerCase())}}
                      </el-radio-button>
                    </el-radio-group>
                  </div>
                  <div v-if="child_question.type === 'Combobox'">
                    <el-select size="large"
                               placeholder="Single Select"
                               :name="child_question.valueHolder === undefined || child_question.valueHolder.length === 0 ? 'invalidQuestion' : ''"
                               @change="onAnswerChange(child_question)"
                               filterable
                               v-model="child_question.valueHolder">
                      <el-option v-for="option in child_question.sorted_answer_ids"
                                 v-if="child_question['answers'][option]['available']"
                                 class="select-danger"
                                 :class="child_question['answers'][option]['strikethrough'] === true ? 'strikethrough' : ''"
                                 :value="child_question['answers'][option].name"
                                 :label="computeCaption(child_question.answers[option].name, $store.state.lang.value.toLowerCase())"
                                 :key="option">
                      </el-option>
                    </el-select>
                  </div>
                  <div v-if="child_question.type === 'Multichoice' || child_question.type === 'Multichoice Toggle'">
                    <el-select size="large"
                               v-model="child_question.multiple"
                               @change="onAnswerChange(child_question)"
                               :name="child_question.multiple === undefined || child_question.multiple.length === 0 ? 'invalidQuestion' : ''"
                               multiple
                               filterable
                               collapse-tags
                               placeholder="Select">
                      <el-option
                        class="select-danger"
                        :class="child_question['answers'][answer_id]['strikethrough'] === true ? 'strikethrough' : ''"
                        v-for="answer_id in child_question.sorted_answer_ids"
                        v-if="child_question['answers'][answer_id]['available']"
                        :key="answer_id"
                        :label="child_question['answers'][answer_id].name"
                        :value="child_question['answers'][answer_id].name">
                        {{ computeCaption(question['answers'][answer_id].name, $store.state.lang.value.toLowerCase()) }}
                      </el-option>
                    </el-select>
                  </div>
                  <div v-if="child_question.type === 'Barcode'">
                    <scanning-module usage="questions" :question="child_question"></scanning-module>
                  </div>
                  <div v-if="child_question.type === 'Text'">
                    <el-input
                      type="textarea"
                      :name="child_question.value === null || child_question.value.length === 0 ? 'invalidQuestion' : ''"
                      autosize
                      class="w-100"
                      @input="onAnswerChange(child_question)"
                      v-model="child_question.value"
                      onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
                    </el-input>
                  </div>
                  <div v-if="child_question.type === 'Number'">
                    <el-input
                      type="number"
                      inputmode="numeric"
                      :name="child_question.value === null || child_question.value.length === 0 ? 'invalidQuestion' : ''"
                      autosize
                      class="w-100"
                      @input="onAnswerChange(child_question)"
                      v-model="child_question.value"
                      onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
                    </el-input>
                  </div>
                  <div v-if="child_question.type === 'Date'">
                    <el-date-picker
                      v-model="child_question.value"
                      type="date"
                      :name="child_question.value === null || child_question.value.length === 0 ? 'invalidQuestion' : ''"
                      class="w-100"
                      format="MM/dd/yyyy"
                      value-format="yyyy-MM-dd"
                      placeholder="Select date"
                      :picker-options="{disabledDate: (time) => checkDisabledDateQuestion(time, child_question)}">
                    </el-date-picker>
                  </div>
                  <div class="default-grey font-small" v-show="getQuestionDescription(child_question)" v-html="getQuestionDescription(child_question) || ''"></div>
                  <small class="text-danger el-col-md-offset-1" v-if="$store.state.questionsErrorArray.includes(child_question['id'])">
                    {{ computeCaption('This field is required', $store.state.lang.value.toLowerCase()) }}
                  </small>
                </div>
                <div v-if="child_question.type === 'Combobox' || child_question.type === 'Multichoice' || child_question.type === 'Combobox Toggle' || child_question.type === 'Multichoice Toggle'">
                  <recursive-question :question="child_question"></recursive-question>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>


      <script>
    import {Button, RadioGroup, Radio, RadioButton, DatePicker, Input} from 'element-ui'
    import ScanningModule from './ScanningModule'
    import {TranslationsUtils} from '../../../../utils/Translations'
    import {QuestionUtils} from '../../../../utils/Questions'
    export default {
      name: 'RecursiveQuestion',
      mixins: [TranslationsUtils, QuestionUtils],
      components: {
        ScanningModule,
        [Input.name]: Input,
        [DatePicker.name]: DatePicker,
        [Button.name]: Button,
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
        [RadioButton.name]: RadioButton },
      props: ['question'],
      data () {
        return {
          condition: ''
        }
      },
      methods: {
        onAnswerChange (question) {
          let answers = Object.values(question['answers'])
          answers.forEach(function (answer) {
            if (answer.name === question.valueHolder) {
              question.value = {answer_id: answer.id, answer_name: answer.name}
              question['multiple_ids'] = []
              question['multiple_ids'].push(answer.id)
            }
          })
          if (question.type === 'Multichoice' || question.type === 'Multichoice Toggle') {
            question['multiple_ids'] = []
            let objectOfAnswer = Object.values(question['answers'])
            let possibleAnswers = []
            objectOfAnswer.forEach(element => possibleAnswers.push(element['name']))
            let possibleAnswersKeys = Object.keys(question['answers'])
            let multipleAnswersArray = question['multiple']
            multipleAnswersArray.forEach(function (answerName) {
              let answerIndex = possibleAnswers.indexOf(answerName)
              if (answerIndex !== -1) {
                question['multiple_ids'].push(possibleAnswersKeys[answerIndex])
              }
            })
          }
          question.valid = !!question.value
        }
      },
      created () {
        this.question['multiple_ids'] = this.question['multiple_ids'] !== undefined && this.question['multiple_ids'].length !== -1 ? this.question['multiple_ids'] : []
        this.question.value = this.question.value ? this.question.value : []
        this.condition = this.question ? (this.question.value ? (this.question['multiple_ids'].length !== -1) : false) : false
      }
    }
</script>

<style scoped lang="scss">
@import '../../../../assets/sass/paper/_variables.scss';
  .padding {
    padding-top: 1vh;
  }

  .w-100{
    width: 100% !important;
  }
  .strikethrough {
    text-decoration: line-through;
    text-decoration-color: $primary-color;
    text-decoration-thickness: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/RecursiveQuestions.vue